// import ResizableBox from "../ResizableBox";
import React, {useEffect, useRef, useState} from "react";
import CanvasJSReact from '../canvasjs.react';
import DropableLabel from "./DropableLabel";
import CorrectIcon from "../images/CorrectIcon.svg"
import InCorrectIcon from "../images/incorrectIcon.svg"
import "animate.css/animate.css";
import questionsAnswers from "../containers/questionAnswers"
import supplyIcon from "../images/Supply.svg"
import SocialCost from "../images/Social-cost.svg"
import DemandIcon from "../images/Demand.svg"
import taxLabel from "../images/Tax-label.svg"
import { Grid, Typography } from "@material-ui/core";
import styles from "./BubbleLine1Styles";
import withStyles from "@material-ui/core/styles/withStyles";
import { isMobile, isTablet } from "react-device-detect";

var CanvasJSChart = CanvasJSReact.CanvasJSChart;

const BubbleAndLine7 = (props) => {
  const [allCorrect, setAllCorrect] =useState(false)
  const { qIndex, setCurrentScreen, classes } = props;
  const [chartData, setChartData] =useState([])
  const [submit, setSubmit] =useState(false)
  const [buyerTax, setBuyerTax] = useState(0)
  const canvasRef = useRef(null);

  // State to keep track of the selected option
  const [selectedParagraph, setSelectedParagraph] = useState("");

  // Define the letters for each option
  const optionLabels = ['a.', 'b.', 'c.'];

  let data = [
    {
      type: "line",
      color: 'transparent',
      dataPoints: []
    },
    {
      type: "spline",
      color: "#8C479B",
      lineThickness: isMobile ? 3 : 5,
      dataPoints: [{x: 10, y: 16, cursor: 'pointer', z: 3}, {x: 50, y: 20, cursor: 'pointer', z: 3}, {x: 150, y: 30, cursor: 'pointer', z: 3}, {x: 250, y: 40, cursor: 'pointer', z: 3}, {x: 290, y: 44, cursor: 'pointer', z: 3}]
    },
    {
      type: "spline",
      color: '#003e4c',
      lineThickness: isMobile ? 3 : 5,
      dataPoints: [{x: 10, y: 6, cursor: 'pointer', z: 1}, {x: 50, y: 10, cursor: 'pointer', z: 1}, {x: 150, y: 20, cursor: 'pointer', z: 1}, {x: 250, y: 30, cursor: 'pointer', z: 1}, {x: 290, y: 34, cursor: 'pointer', z: 1}]
    },
    {
      type: "spline",
      color: '#00b1d9',
      lineThickness: isMobile ? 3 : 5,
      dataPoints: [{x: 10, y: 34, cursor: 'pointer'}, {x: 100, y: 25, cursor: 'pointer'}, {x: 200, y: 15, cursor: 'pointer'}, {x: 250, y: 10, cursor: 'pointer'}, {x: 290, y: 6, cursor: 'pointer'}]
    },
    {
      type: "scatter",
      markerSize: 15,
      color: 'green',
      dataPoints: []
    },
    {
      type: "scatter",
      markerSize: 15,
      color: 'red',
      dataPoints: []
    },
  ]

  useEffect(() => {
    setChartData(data)
  }, [])

  useEffect(() => {
    if(submit === true){
      setAllCorrect(buyerTax === 10)
    }
  },[submit])

  const options = {
    colorSet: "colorSet2",
    cursor: "pointer",
    title: {
      text: isMobile ? "" : "Supply of Snow Globes",
      fontColor: "#transparent",
      // fontColor: "#003e4c",
      fontFamily: "Rubik",
      fontWeight: "bold",
      fontSize: 24,
    },
     axisX:{
      lineColor: "#003e4c",
      lineThickness: 3,
      gridThickness: 1,
      gridColor: "#cecece",
      labelFontColor: "#003e4c",
      labelFontSize: isMobile ? 12 : 16,
      // labelFontWeight: "bold",
      labelFontFamily: "Rubik",
      interval: questionsAnswers[qIndex].step,
      minimum: 0,
      maximum: questionsAnswers[qIndex].xmax,
    },
    axisY:{
      lineColor: "#003e4c",
      lineThickness: 3,
      labelFontSize: isMobile ? 12 : 16,
      labelFontFamily: "Rubik",
      gridThickness: 1,
      labelFontColor: "#003e4c",
      gridColor: "#cecece",
      interval:  questionsAnswers[qIndex].stepY,
      minimum: 0,
      maximum: questionsAnswers[qIndex].ymax,
      margin: 10
    },
    toolTip: {
      enabled: false,
    },
    data: chartData,
    height: isMobile && 200,
    width: isMobile && 320
  }

  function getButtonText() {
    if(submit){
      return allCorrect ? "Next" : "Try Again"
    }else{
      return "Submit"
    }
  }

  const clearScreen = () => {
    setSubmit(false)
    setSelectedParagraph("")
  }

  function submitButtonAction() {
    if(submit){
      if(!allCorrect){
        clearScreen()
      }
    }else{
      setSubmit(true)
    }
  }

  const getOptionBackgroundColor = (index) => {
    if(submit){
      return selectedParagraph === index ? allCorrect ? "green" : "red" : "transparent"
    }else{
      return selectedParagraph === index ? "#00b1d9" :  'transparent'
    }
  }

  return (
    <>
      <div className={classes.mainContainer}>
        <div className={classes.leftContainer4}>
          <div style={{ display: "flex", justifyContent: "flex-start", flexDirection: "column" }}>
           <div style={{ display: "flex", flexDirection: "column", width: "90%", paddingLeft: "5%", alignItems: "flex-start", paddingTop: "5%" }}>
            <h3 className={classes.questionText6}>{questionsAnswers[qIndex].question}</h3>
            <div style={{ display: "flex", flexDirection: "column", width: "95%", alignItems: "start", paddingLeft: "2%" }} className="animate__animated animate__bounceIn">

            <div style={{ display: "flex", flexDirection: "column", width: "100%", alignItems: "start", paddingLeft: "1%" }} className="animate__animated animate__bounceIn">

              <p className={classes.questionText7}>
                Using the graph, what is the per unit tax amount that would move the market to the socially optimal level?
              </p>
              <div style={{ display: "flex", alignItems: "center" }}>
                <button className={classes.incrementButton3} disabled={buyerTax === 0 || submit} onClick={() => setBuyerTax(buyerTax-5)}><b>-</b></button>
                <p className={classes.valueText3} style={{ color: submit ? buyerTax === 10 ? "green" : "red" : "#043e4b" }}>${buyerTax}</p>
                <button className={classes.incrementButton3} disabled={submit} onClick={() => setBuyerTax(buyerTax+5)}><b>+</b></button>
              </div>

            </div>
          </div>

            {submit && 
            <div className={classes.answerTextContainer}>
              {!allCorrect ?
                <div className={classes.incorrectAnswerContainer}>
                  <img src={InCorrectIcon} alt="InCorrectIcon" className={classes.icon}/>
                </div>
              : 
              <Grid container className={classes.correctAnswerContainer}>
                <img src={CorrectIcon} alt="CorrectIcon" className={classes.icon}/>
                <Typography className={classes.answerText}>
                  A tax of $10, equal to the external cost, will move the market to the socially efficient equilibrium of Q=100.
                </Typography>
              </Grid>
              }
            </div>
            }
           </div>
          </div>
        </div>
        <div className={`animate__animated animate__bounceIn ${classes.rightContainer}`}>
        <DropableLabel
            right={'-20%'}
            marginTop={isMobile ? "10%" : "25%"}
            rotate={"rotate(270deg)"}
            label={"PRICE"}
          />
          <p className={classes.graphTitle}>{questionsAnswers[qIndex].title}</p>
          <img src={SocialCost} alt="" className={classes.socialCostIcon} />
          <img src={supplyIcon} alt="" className={classes.supplyIcon} />
          <img src={DemandIcon} alt="" className={classes.demandIcon} />
          <CanvasJSChart options = {options}  ref={canvasRef}/>
          <DropableLabel
            right={"75%"}
            marginTop={"0%"}
            rotate={"rotate(0deg)"}
            label={"QUANTITY"}
          />
          {allCorrect &&
            <img src={taxLabel} alt="" className={classes.taxIcon}/>
          }

          {/* <img src={DemandIcon} alt="" style={{ height: 80, width: 80, position: "absolute", zIndex: 10, right: "-12%", top: 380 }}/> */}
          {/* {submit && (getLabeltext() || getAnswertext()) &&
            <div style={{ display: "flex", top: 0, height: "78%", width: "100%", position: "absolute", zIndex: 1, background: "rgba(152, 152, 152, 0.5)" }}>
            </div>
          } */}
          <div className={classes.buttonContainer6}>
            {
            getButtonText() !== 'Next' ? (<>
              <button className={classes.buttonSubmit6} onClick={() => submitButtonAction()}>{getButtonText()}</button>
              <button className={classes.clearButton6} onClick={() => clearScreen()}>Clear</button>
              </>) : <button className={classes.nextButton6} onClick={() => setCurrentScreen("Result")}>{getButtonText()}</button>
            }
          </div>
        </div>
      </div>
    </>
  )

}
export default withStyles(styles)(BubbleAndLine7);
